import { render, staticRenderFns } from "./review-body.vue?vue&type=template&id=6db60359&"
import script from "./review-body.vue?vue&type=script&lang=ts&"
export * from "./review-body.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports